(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  customElements.whenDefined('details-disclosure').then(() => {
    class FooterMenu extends DetailsDisclosure {
      constructor() {
        super();
        this.reset();
        window.addEventListener('on:breakpoint-change', this.reset.bind(this));
      }

      /**
       * AGT: Auf Mobil bleiben die Menüs aufgeklappt.
       *
       * Vorher stand hier:
       *   this.disclosure.open = isLargeScreen || isConfirmNewsletter;
       *
       * Im Markup steht bereits <details ... open>, serverseitig ist
       * also alles offen. Diese Zeile hat es auf schmalen Bildschirmen
       * beim Laden wieder zugeklappt.
       *
       * Der Parameter unterscheidet die beiden Aufrufe: Aus dem
       * Konstruktor kommt nichts, vom Breakpoint-Listener kommt ein
       * Event. Nur beim ersten Lauf wird aufgeklappt - sonst würde
       * ein Menü, das der Besucher gerade zugeklappt hat, beim
       * Drehen des Geräts wieder aufspringen.
       */
      reset(event) {
        const isLargeScreen = window.matchMedia(theme.mediaQueries.md).matches;

        if (!event || isLargeScreen) {
          this.disclosure.open = true;
        }

        /* Auf großen Bildschirmen ist der Umschalter ohne Funktion,
           dort gehört er aus der Tab-Reihenfolge heraus. Auf Mobil
           bleibt er bedienbar: aufgeklappt ist der Startzustand,
           keine Zwangsjacke. */
        if (isLargeScreen) {
          this.toggle.setAttribute('tabindex', '-1');
        } else {
          this.toggle.removeAttribute('tabindex');
        }
      }
    }

    customElements.define('footer-menu', FooterMenu);
  });

  } catch(e) { console.error(e); }
})();
})();
